<template>
  <div class="">
    <b-table striped hover small :fields="fields" :items="items"></b-table>
  </div>
</template>

<script>
export default {
  name: 'TicketDetails',
  props: ['ticket'],
  computed: {
    items() {
      return [
        { label: 'Ticket #', value: this.ticket.number},
        { label: 'Ticket Type', value: this.ticket.type},
        { label: 'Subject', value: this.ticket.subject},
        { label: 'Description', value: this.ticket.description},
        { label: 'Reference Url', value: this.ticket.url}
      ];
    }
  },
  data() {
    return {
      fields: [
        { key: 'label', label: '', tdClass: ['font-weight-bold'], thClass: ['d-none'] },
        { key: 'value', label: '', thClass: ['d-none'] },
      ],
    };
  },
}
</script>
